// The practitioner's PUBLIC PROFILE editor (`admin/PublicProfileAdmin.jsx`) — everything the
// marketplace's "Get to know" block says about the practice in the practitioner's own words.
//
// The copy talks about VISITORS on purpose: every field here is published, and the editor's
// job is to make that plain before the practitioner types anything they would not put on a
// public page.
export default {
  fr: {
    "nav.publicProfile": "Profil public",

    "pp.title": "Profil public",
    "pp.subtitle": "Ce que les visiteurs du marketplace lisent sur vous. Tout ce qui est rempli ici est public.",
    "pp.save": "Enregistrer",
    "pp.saved": "Profil public enregistré",
    "pp.saveError": "Le profil n'a pas pu être enregistré",
    "pp.viewPublic": "Voir ma page publique",

    "pp.photo.label": "Photo",
    "pp.photo.hint": "Un portrait net et souriant. Sans photo, votre logo est utilisé.",
    "pp.photo.upload": "Choisir une photo",
    "pp.photo.remove": "Retirer",
    "pp.photo.uploaded": "Photo ajoutée",
    "pp.photo.uploadError": "La photo n'a pas pu être envoyée",

    "pp.headline.label": "Titre",
    "pp.headline.hint": "Une ligne sous votre nom, par exemple « Ostéopathe pour toute la famille ».",
    "pp.bio.label": "Description",
    "pp.bio.hint": "Qui vous êtes, ce que vous faites, pour qui. Les retours à la ligne sont conservés.",
    "pp.counter": "{n}/{max}",

    "pp.specialty.label": "Spécialité principale",
    "pp.specialty.none": "Aucune",
    "pp.specialties.label": "Spécialités affichées",
    "pp.country.label": "Pays",
    "pp.country.none": "Non précisé",
    "pp.languages.label": "Langues parlées",
    "pp.languages.hint": "Choisissez toutes les langues dans lesquelles vous recevez vos clients.",

    "pp.preview.title": "Aperçu",
    "pp.preview.hint": "Exactement ce que verra un visiteur.",

    "branding.profileMoved": "Le titre et les spécialités se modifient désormais dans votre profil public.",
    "branding.profileMovedLink": "Ouvrir le profil public",
  },
  en: {
    "nav.publicProfile": "Public profile",

    "pp.title": "Public profile",
    "pp.subtitle": "What marketplace visitors read about you. Everything filled in here is public.",
    "pp.save": "Save",
    "pp.saved": "Public profile saved",
    "pp.saveError": "The profile could not be saved",
    "pp.viewPublic": "View my public page",

    "pp.photo.label": "Photo",
    "pp.photo.hint": "A clear, friendly portrait. Without one, your logo is used.",
    "pp.photo.upload": "Choose a photo",
    "pp.photo.remove": "Remove",
    "pp.photo.uploaded": "Photo added",
    "pp.photo.uploadError": "The photo could not be uploaded",

    "pp.headline.label": "Headline",
    "pp.headline.hint": "One line under your name, for example “Osteopath for the whole family”.",
    "pp.bio.label": "Description",
    "pp.bio.hint": "Who you are, what you do and who you work with. Line breaks are kept.",
    "pp.counter": "{n}/{max}",

    "pp.specialty.label": "Primary specialty",
    "pp.specialty.none": "None",
    "pp.specialties.label": "Specialties shown",
    "pp.country.label": "Country",
    "pp.country.none": "Not specified",
    "pp.languages.label": "Languages spoken",
    "pp.languages.hint": "Choose every language you see clients in.",

    "pp.preview.title": "Preview",
    "pp.preview.hint": "Exactly what a visitor will see.",

    "branding.profileMoved": "Your headline and specialties are now edited in your public profile.",
    "branding.profileMovedLink": "Open the public profile",
  },
  es: {
    "nav.publicProfile": "Perfil público",

    "pp.title": "Perfil público",
    "pp.subtitle": "Lo que los visitantes del marketplace leen sobre usted. Todo lo que complete aquí es público.",
    "pp.save": "Guardar",
    "pp.saved": "Perfil público guardado",
    "pp.saveError": "No se pudo guardar el perfil",
    "pp.viewPublic": "Ver mi página pública",

    "pp.photo.label": "Foto",
    "pp.photo.hint": "Un retrato nítido y cercano. Sin foto, se usa su logotipo.",
    "pp.photo.upload": "Elegir una foto",
    "pp.photo.remove": "Quitar",
    "pp.photo.uploaded": "Foto añadida",
    "pp.photo.uploadError": "No se pudo subir la foto",

    "pp.headline.label": "Titular",
    "pp.headline.hint": "Una línea bajo su nombre, por ejemplo «Osteópata para toda la familia».",
    "pp.bio.label": "Descripción",
    "pp.bio.hint": "Quién es, qué hace y con quién trabaja. Se conservan los saltos de línea.",
    "pp.counter": "{n}/{max}",

    "pp.specialty.label": "Especialidad principal",
    "pp.specialty.none": "Ninguna",
    "pp.specialties.label": "Especialidades mostradas",
    "pp.country.label": "País",
    "pp.country.none": "Sin especificar",
    "pp.languages.label": "Idiomas hablados",
    "pp.languages.hint": "Elija todos los idiomas en los que atiende a sus clientes.",

    "pp.preview.title": "Vista previa",
    "pp.preview.hint": "Exactamente lo que verá un visitante.",

    "branding.profileMoved": "El titular y las especialidades ahora se editan en su perfil público.",
    "branding.profileMovedLink": "Abrir el perfil público",
  },
};
